import { useEffect } from 'react';
import { useRouter } from 'next/router';
import { useQuery } from 'react-query';
import { boardsServices } from '@services';
import { showError } from '@utils';
import { QUERY_KEYS } from 'constants/queryKeys';
import { useAssignees } from 'hooks/common';
import { GENERIC_TICKETS_STATUS_OPTIONS } from 'components/genericTickets/constants';
import { useTeams } from 'components/common/QuickTicketCreationForm/hooks';
import { handleGenericTicket } from './utils';

export const useGenericTicketOperations = () => {
  const router = useRouter();
  const tab = router.query?.tab;
  const {
    activeTeams: teams,
    isLoading: teamsLoading,
    isFetched: isTeamsFetched,
  } = useTeams();
  const genericTicketId = router.query?.genericTicketId;
  const {
    assigneesMap,
    assignees,
    isFetched: isAssigneesFetched,
    isLoading: isAssigneesLoading,
  } = useAssignees();

  const genericTicketResponse = useQuery(
    [QUERY_KEYS.GET_GENERIC_TICKET_KEY, genericTicketId],
    () => boardsServices.getTaskById(genericTicketId),
    {
      enabled: isAssigneesFetched && !!genericTicketId && isTeamsFetched,
    }
  );

  const stages = GENERIC_TICKETS_STATUS_OPTIONS;

  const genericTicket = handleGenericTicket(
    genericTicketResponse?.data?.data,
    stages,
    teams
  );

  const loading =
    isAssigneesLoading || genericTicketResponse.isLoading || teamsLoading;

  useEffect(() => {
    if (genericTicketResponse?.isError) {
      showError(genericTicketResponse?.error);
    }
  }, [genericTicketResponse?.isError]); // eslint-disable-line react-hooks/exhaustive-deps

  return {
    genericTicketId,
    assignees,
    assigneesMap,
    genericTicket,
    stages,
    loading,
    teams,
    tab,
    getGenericTicket: genericTicketResponse?.refetch,
  };
};
